import React, { Component } from "react";
import autoBind from "auto-bind";
import { connect } from "react-redux";

import { ceScreenViewTextVersionOpen } from "@js/actions/studio/campaign_content_section/screen_view_text_version.js";
import { ceScreenViewWebVersionOpen } from "@js/actions/studio/campaign_content_section/screen_view_web_version.js";
import { ceScreenEditorOpen } from "@js/actions/studio/campaign_content_section/screen_editor.js";
import { ceModalUploadFromFileOpen } from "@js/actions/studio/campaign_content_section/modal_upload_from_file.js";
import { ceModalUploadFromUrlOpen } from "@js/actions/studio/campaign_content_section/modal_upload_from_url.js";

import RenderedHtmlImage from "@js/components/studio/utilities/rendered_html_image.jsx";

import classNames from "@js/helpers/class_names.js";

const OverlaySection = connect()((props) => {
  let content = props.content;
  if (!content) return null;
  let actionsAreHTML = content.format !== "text";
  let editAction = ceScreenEditorOpen(
    content.client_content_id,
    actionsAreHTML ? "html" : "text",
  );
  let viewAction = actionsAreHTML
    ? ceScreenViewWebVersionOpen(content.client_content_id)
    : ceScreenViewTextVersionOpen(content.client_content_id);
  let isBlank = actionsAreHTML ? content.html === "" : content.text === "";
  let showOverlay = props.visible || isBlank;

  let containerClasses = classNames({
    "studio-campaign-content-tile-overlay": true,
    "studio-campaign-content-tile-overlay--visible": showOverlay,
    "studio-campaign-content-tile-overlay--hidden": !showOverlay,
    "studio-campaign-content-tile-overlay--blank": isBlank,
  });

  return (
    <div className={containerClasses}>
      {isBlank && (
        <div className="studio-campaign-content-tile-overlay--warning">
          {content.format === "text"
            ? t(`phrases.react_content.content_row.text_part_not_defined`)
            : t(`phrases.react_content.content_row.content_not_defined`)}
        </div>
      )}
      {props.allow_editing && (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            props.dispatch(editAction);
          }}
          className="button btn btn-primary"
        >
          {t(`buttons.edit`)}
        </a>
      )}
      {!isBlank && (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            props.dispatch(viewAction);
          }}
          className="button btn diminished-button"
        >
          {t(`buttons.view`)}
        </a>
      )}
      {isBlank && props.allow_editing && (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            props.dispatch(
              ceModalUploadFromFileOpen(content.client_content_id),
            );
          }}
          className="studio-link-button top-link"
        >
          {t(`phrases.react_content.action_dropdown.import_from_file`)}
        </a>
      )}
      {isBlank && props.allow_editing && (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            props.dispatch(ceModalUploadFromUrlOpen(content.client_content_id));
          }}
          className="studio-link-button"
        >
          {t(`phrases.react_content.action_dropdown.import_from_url`)}
        </a>
      )}
    </div>
  );
});

class StudioCampaignContentTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlayIsVisible: false,
    };

    autoBind(this);
  }

  showOverlay() {
    this.setState({
      overlayIsVisible: true,
    });
  }

  hideOverlay() {
    this.setState({
      overlayIsVisible: false,
    });
  }

  render() {
    let content = this.props.content;
    if (!content || content.deleted) {
      return null;
    }
    return (
      <div
        className="studio-campaign-content-tile"
        onMouseEnter={this.showOverlay}
        onMouseLeave={this.hideOverlay}
      >
        <OverlaySection
          content={this.props.content}
          visible={this.state.overlayIsVisible}
          allow_editing={this.props.allow_editing}
        />
        <RenderedHtmlImage
          {...this.props.content.preview_image}
          allow_editing={this.props.allow_editing}
        />
      </div>
    );
  }
}

export default connect()(StudioCampaignContentTile);
